import React from "react";
import { EuiFlexGroup, EuiSpacer, EuiHideFor, EuiFlexItem } from "@elastic/eui";
import { useSelector } from "react-redux";
import Drawer from "./drawer";
import Header from "./header/header";
import * as S from "./style";
import Notification from "../notification";
import { fullPageLoaderSelector } from "../FullPageLoader/slice";
import FullPageLoader from "../FullPageLoader/components";

function MainLayout({ children, isPanelTransparent }) {
    const isPageLoading = useSelector(fullPageLoaderSelector());
    return (
        <S.MainPage>
            <EuiHideFor sizes={["xs", "s"]}>
                <EuiSpacer size="xl" />
            </EuiHideFor>
            <EuiSpacer size="xl" />
            <Header />
            <S.ContentWrapper>
                <div className="drawer">
                    <Drawer />
                </div>
                <EuiFlexGroup>
                    <EuiFlexItem className="main-page-container">
                        {children}
                        {isPageLoading && <FullPageLoader />}
                    </EuiFlexItem>
                </EuiFlexGroup>
            </S.ContentWrapper>
            <Notification />
        </S.MainPage>
    );
}

export default MainLayout;
